module.exports = __webpack_public_path__ + "static/media/sync.adfa0819.svg";